import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

/**
 * Centered illustration + title + description + optional CTA. Used as the
 * "no results" state across the eshop (shop catalogue, basket, orders,
 * invoices...). Mirrors the spacing/tone of the fitter dashboard cards.
 */
export const EmptyState = ({
  icon,
  title,
  description,
  action,
  sx,
}) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      py: { xs: 6, md: 10 },
      px: 2,
      ...sx,
    }}
  >
    <Box
      sx={{
        width: 88,
        height: 88,
        borderRadius: "50%",
        bgcolor: "rgba(245, 166, 35, 0.12)",
        color: "secondary.main",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 3,
        "& svg": { fontSize: 44 },
      }}
    >
      {icon || <InboxOutlinedIcon />}
    </Box>
    <Typography
      variant="h6"
      sx={{ fontWeight: 700, color: "text.primary", mb: 1 }}
    >
      {title}
    </Typography>
    {description && (
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ maxWidth: 420, mb: action ? 3 : 0 }}
      >
        {description}
      </Typography>
    )}
    {action && <Stack direction="row" spacing={1.5}>{action}</Stack>}
  </Box>
);
